module.exports = __webpack_public_path__ + "img/icon.cfc97308.svg";